import { AuthorizationEnum } from "../enums/authorization-enum";

export class UserDto {
  id?: number;
  username?: string;
  token?: string;
  auth: AuthorizationEnum;
  plants?: number[];
}
